const shuttleReports = {
  actions: {
    export: 'Exportar',
  },

  table: {
    headers: {
      tripId: 'ID de expedición',
      routingType: 'Tipo de ruta',
      reservationId: 'ID de reserva',
      externalId: 'ID externo',
      reservationStatus: 'Estado de la reserva',
      tripStatus: 'Estado de la expedición',
      date: 'Fecha',
      dateType: 'Tipo de fecha',
      passenger: 'Pasajero',
      email: 'Correo electrónico',
      phone: 'Telefono',
      seats: 'Asientos',
      supplier: 'Proveedor',
      shuttle: 'Shuttle',
      line: 'Línea',
      from: 'De',
      to: 'Hacia',
      driver: 'Conductor',
      vehicle: 'Vehículo',
      paymentType: 'Tipo de pago',
      paymentDetails: 'Detalles de pago',
      profile: 'Perfil',
      shuttleArea: 'Zona',
      dropOff: 'Dejar',
      area: 'Zona',
      direction: 'Dirección',
      price: 'Precio',
      pickedTime: 'Hora Recogida',
      droppedTime: 'Hora Dejada',
      noshowTime: 'Hora de No-Show',
      shuttleFare: 'Tarifa de Shuttle',
    },

    cells: {
      reservationStatus: {
        options: {
          new: 'Nuevo',
          onhold: 'En espera',
          cancelled: 'Cancelado',
          routing: 'Ruteo',
          routed: 'Ruteado',
          picked: 'Recogido',
          dropped: 'Dejado',
          noshow: 'Noshow',
        },
      },
    },

    filters: {
      reservationStatus: {
        options: {
          new: 'Nuevo',
          onhold: 'En espera',
          cancelled: 'Cancelado',
          routing: 'Ruteo',
          routed: 'Ruteado',
          picked: 'Recogido',
          dropped: 'Dejado',
          noshow: 'Noshow',
        },
      },
      tripStatus: {
        options: {
          new: 'Nuevo',
          inroute: 'En ruta',
          sent: 'Enviado',
          approved: 'Aprobado',
          pickingUp: 'Recogida',
          done: 'Listo',
          cancelled: 'Cancelado',
        },
      },
      routingType: {
        options: {
          bus: 'Autobús',
          demand: 'Demanda',
          dynamic: 'Dinámicos',
        },
      },
    },
  },
  tableSummary: {
    title: 'Informes de Shuttle',
    headers: {
      trips: 'Viajes',
      reservations: 'Reservas',
      passengers: 'Pasajeros',
      uniquePassengers: 'Pasajeros únicos',
    },
  },
};

export default shuttleReports;
